module.exports = __webpack_public_path__ + "img/zhuanjiazhenfei.8e2a6087.png";